import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContactComponent } from './contact.component';
import { ContactViewComponent } from './contact-view/contact-view.component';
import { ContactCustomerPortifolioComponent } from './contact-customer-portfolio/contact-customer-portfolio.component';


const routes: Routes = [
  { path: '', component: ContactComponent, },
  { path: 'view/:id', component: ContactViewComponent, },
  { path: 'customer-portfolio/:id', component: ContactCustomerPortifolioComponent, },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContactRoutingModule { }
